/** True when the current route and loader profile carry the Place button (see visibility.ts). */
import { useLocation } from 'react-router';
import { useLoader } from '../store';
import { modeFromPathname, placeButtonVisible } from './visibility';

export function usePlaceAvailable(): boolean {
  const { pathname } = useLocation();
  const profile = useLoader((s) => s.profile);
  return placeButtonVisible(modeFromPathname(pathname), profile);
}
